<template>
  <div class="w-full">
    <SideBar
      title="REENVIAR RPS "
      @hide="close()"
      :active="modal"
      size="large"
      :visualizar="blockActions"
      textSucces="Reenviar"
      icon="note"
      @success="submitForm()"
    >
      <div slot="body" class="mx-2">
        <div
          class="w-full vs-con-loading__container"
          :id="'loadingNota' + fatura.id"
        >
          <div class="w-full">
            <VuePerfectScrollbar
              class="scroll-reenviar-rps"
              :settings="settings"
            >
              <div class="w-full">
                <vs-alert
                  v-if="bloqueioEmissaoMotivo"
                  color="danger"
                  icon="warning"
                  active="true"
                  class="mb-3"
                >
                  <b>Emissão Bloqueada:</b> {{ bloqueioEmissaoMotivo }}
                </vs-alert>
                <Tomador :cliente="cliente" />

                <vs-row
                  vs-justify="center"
                  vs-align="flex-start"
                  vs-type="flex"
                >
                  <vx-card no-shadow card-border>
                    <vs-row
                      vs-justify="center"
                      vs-align="center"
                      vs-type="flex"
                    >
                      <vs-col
                        vs-w="3"
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                      >
                        <div class="w-full mx-2">
                          <vs-input
                            color="dark"
                            class="w-full"
                            type="number"
                            name="rps"
                            v-validate="'required'"
                            label="RPS"
                            v-model="nota.rps_novo"
                          ></vs-input>
                          <vs-row>
                            <span
                              style="font-size: 12px"
                              class="text-danger mx-3"
                              v-show="errors.has('rps')"
                              >{{ $validators.empty }}</span
                            >
                          </vs-row>
                        </div>
                      </vs-col>
                      <vs-col
                        vs-w="3"
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                      >
                        <div class="w-full mx-2">
                          <vs-input
                            color="dark"
                            class="w-full"
                            name="valorDoc"
                            type="text"
                            disabled="true"
                            label="Valor Bruto"
                            icon="R$"
                            icon-after="true"
                            v-model="nota.valor_bruto"
                          ></vs-input>
                        </div>
                      </vs-col>
                      <vs-col
                        vs-w="3"
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                      >
                        <div class="w-full mx-2">
                          <vs-input
                            color="dark"
                            class="w-full"
                            name="valorDoc"
                            type="text"
                            v-validate="'required'"
                            label="Valor Líquido"
                            icon="R$"
                            icon-after="true"
                            @change="
                              desconto = 0;
                              nota.iss_retido = 0;
                              reRenderComponents += 1;
                            "
                            :key="reRenderComponents"
                            v-model="nota.valor_liquido"
                          ></vs-input>
                          <vs-row>
                            <span
                              style="font-size: 12px"
                              class="text-danger mx-3"
                              v-show="errors.has('valorDoc')"
                              >{{ $validators.empty }}</span
                            >
                          </vs-row>
                        </div>
                      </vs-col>
                      <vs-col
                        vs-w="3"
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                      >
                        <div class="mx-2">
                          <vs-checkbox
                            color="success"
                            @change="descontoValor($event.type)"
                            :key="reRenderComponents"
                            v-model="nota.iss_retido"
                            class="pt-5"
                            >RETER ISS</vs-checkbox
                          >
                        </div>
                      </vs-col>
                    </vs-row>
                    <vs-row
                      vs-w="12"
                      vs-justify="center"
                      vs-align="flex-start"
                      vs-type="flex"
                    >
                      <vs-col
                        vs-w="12"
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                      >
                        <div class="w-full px-2 my-3">
                          <vs-textarea
                            style="text-align: justify"
                            height="100"
                            class="m-0"
                            color="dark"
                            v-model="nota.obs"
                            label="Observação (xDescServ)"
                            @input="notaObsEditadoManual = true"
                          />
                        </div>
                        <div class="w-full px-2 my-3">
                          <vs-textarea
                            style="text-align: justify"
                            height="80"
                            class="m-0"
                            color="dark"
                            v-model="infoComplPreview"
                            label="Informações Complementares (xInfComp)"
                            @input="infoComplEditadoManual = true"
                          />
                        </div>
                      </vs-col>

                    </vs-row>
                  </vx-card>
                </vs-row>
                <vs-divider class="my-3 font-semibold">Tributações</vs-divider>
                <vs-row
                  class="my-3"
                  vs-justify="center"
                  vs-align="flex-start"
                  vs-type="flex"
                >
                  <vx-card no-shadow card-border>
                    <vs-row
                      class="mb-2"
                      vs-w="12"
                      vs-justify="flex-start"
                      vs-align="flex-start"
                      vs-type="flex"
                    >
                      <vs-col
                        vs-w="3"
                        class="m-0"
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                      >
                        <vs-input
                          color="dark"
                          class="mx-2"
                          @change="reRenderComponents += 1"
                          name="pis"
                          type="text"
                          min="0"
                          v-validate="'required'"
                          :label="
                            'PIS: ' +
                            (empresa.valorPis ? empresa.valorPis : 0) +
                            '%'
                          "
                          icon="R$"
                          :key="reRenderComponents"
                          icon-after="true"
                          v-model="nota.valorPis"
                        ></vs-input>
                      </vs-col>
                      <vs-col
                        vs-w="3"
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                      >
                        <vs-input
                          color="dark"
                          class="mx-2"
                          name="cofins"
                          type="text"
                          min="0"
                          @change="reRenderComponents += 1"
                          :key="reRenderComponents"
                          v-validate="'required'"
                          :label="
                            'COFINS: ' +
                            (empresa.valorCofins ? empresa.valorCofins : 0) +
                            '%'
                          "
                          icon="R$"
                          icon-after="true"
                          v-model="nota.valorCofins"
                        ></vs-input>
                      </vs-col>
                      <vs-col
                        vs-w="3"
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                      >
                        <vs-input
                          color="dark"
                          class="mx-2"
                          name="csll"
                          @change="reRenderComponents += 1"
                          type="text"
                          :key="reRenderComponents"
                          min="0"
                          v-validate="'required'"
                          :label="
                            'CSLL: ' +
                            (empresa.valorCsll ? empresa.valorCsll : 0) +
                            '%'
                          "
                          icon="R$"
                          icon-after="true"
                          v-model="nota.valorCsll"
                        ></vs-input>
                      </vs-col>
                      <vs-col
                        vs-w="3"
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                      >
                        <vs-input
                          color="dark"
                          class="mx-2"
                          name="ir"
                          type="text"
                          @change="reRenderComponents += 1"
                          :key="reRenderComponents"
                          min="0"
                          :label="
                            'IR: ' +
                            (empresa.valorIr ? empresa.valorIr : 0) +
                            '%'
                          "
                          icon="R$"
                          icon-after="true"
                          v-model="nota.valorIr"
                        ></vs-input>
                      </vs-col>
                      <vs-col
                        vs-w="3"
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                      >
                        <vs-input
                          color="dark"
                          class="mx-2"
                          name="inss"
                          type="text"
                          min="0"
                          :label="
                            'INSS: ' +
                            (empresa.valorInss ? empresa.valorInss : 0) +
                            '%'
                          "
                          icon="R$"
                          :key="reRenderComponents"
                          @change="reRenderComponents += 1"
                          icon-after="true"
                          v-model="nota.valorInss"
                        ></vs-input>
                      </vs-col>
                    </vs-row>
                  </vx-card>
                </vs-row>
                <vs-divider class="my-0 font-semibold"
                  >Datas de Vencimento</vs-divider
                >
                <vs-row
                  class="my-3"
                  vs-justify="center"
                  vs-align="flex-start"
                  vs-type="flex"
                >
                  <vx-card no-shadow card-border :key="reRenderComponents">
                    <vs-row
                      class="mb-2"
                      vs-align="center"
                      vs-justify="flex-start"
                      vs-type="flex"
                      vs-w="12"
                    >
                      <vs-col
                        vs-align="center"
                        vs-justify="center"
                        vs-type="flex"
                        vs-w="4"
                        v-for="(data, index) in datasVencimento"
                        :key="index"
                      >
                        <div class="w-full mx-2">
                          <vs-input
                            :label="'Data Parcela N° ' + (index + 1)"
                            type="date"
                            v-validate="'required'"
                            color="dark"
                            :name="'datas' + index"
                            v-model="datasVencimento[index].data"
                          />
                          <vs-input
                            class="mt-3"
                            :label="'Valor Parcela N° ' + (index + 1)"
                            type="number"
                            v-validate="'required'"
                            color="dark"
                            :name="'valores' + index"
                            v-model="datasVencimento[index].valor"
                          />
                          <vs-row
                            vs-w="12"
                            vs-justify="flex-start"
                            vs-align="center"
                          >
                            <span
                              style="font-size: 12px"
                              class="text-danger"
                              v-show="errors.has('datas' + index)"
                              >{{ $validators.empty }}</span
                            >
                          </vs-row>
                        </div>
                      </vs-col>
                    </vs-row>
                  </vx-card>
                </vs-row>
                <Prestador :empresa="empresa" />
              </div>
            </VuePerfectScrollbar>
          </div>
        </div>
      </div>
    </SideBar>
  </div>
</template>

<script>
import components from "@/components/default/exports.js"
import Tomador from "./tomador"
import Prestador from "./prestador"
import notaObservacaoTemplateMixin from "@/mixins/notaObservacaoTemplate.js"

export default {
  mixins: [notaObservacaoTemplateMixin],
  props: {
    fatura: null,
    contrato: {},
    nota: {}
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      cliente: {},
      empresa: {},

      modal: false,
      jsonNota: {},
      desconto: 0,
      reRenderComponents: 0,
      blockActions: false,
      enderecoFaturamento: {},
      parametros: {},
      textoPorcentagensServico: "",
      tributos: 0,
      datasVencimento: []
    }
  },
  methods: {
    //FUNÇÕES INICIAL
    async openModal () {
      this.resetarEstadoTemplate()
      await this.$vs.loading({
        container: "#loadingNota" + this.fatura.id,
        scale: 0.6
      })
      this.blockActions = true
      this.modal = await true
      try {
        this._beforeEditingCache = await Object.assign({}, this.nota)
        this.parametros = await this.$parametros.get()
        await this.getCliente()
        await this.getEmpresa()
        await this.getEnderecoFaturamento()
        await this.setPorcentagensServico()
        await this.setDatasVencimento()
        await this.setCamposNota()
        await this.montarObs()
      } catch (err) {
        await this.tratarErroHttpPadrao(err)
      } finally {
        this.blockActions = false
        await this.$vs.loading.close(
          "#loadingNota" + this.fatura.id + " > .con-vs-loading"
        )
      }
    },

    //FUNÇÕES SET PARA OS VALORES DO REENVIO DO RPS
    //SETAR OS CAMPOS NECESSARIOS PARA O REENVIO DO RPS
    async setCamposNota () {
      this.nota.rps_novo = this.nota.rps
      this.desconto =
        this.nota.valor_bruto - this.nota.valor_liquido - this.tributos
      // this.desconto = this.nota.valor_bruto - this.nota.valor_liquido
    },
    //SETAR AS DATAS DE VENCIMENTO DAS PARCELAS, DEPENDENDO DO TIPO DO CONTRATO
    async setDatasVencimento () {
      this.datasVencimento = []
      let dataVencimento

      const hasEntrada = this.contrato.entrada > 0 && this.contrato.id_forma_pagamento_entrada > 0 && this.contrato.data_entrada != null

      if (hasEntrada) {
        dataVencimento = await this.$formartData.formatar(
          this.contrato.data_entrada,
          1
        )
      } else {
        dataVencimento = await this.$formartData.formatar(
          this.$formartData.dataHoje(),
          1
        )
        dataVencimento = await this.$formartData.somarDias(dataVencimento, 30)
      }
      if (
        this.contrato.id_tipo_faturamento == 1 ||
        this.contrato.id_tipo_faturamento == 2 ||
        this.contrato.id_tipo_faturamento == 3 ||
        this.contrato.id_tipo_faturamento == 6
      ) {
        if (hasEntrada) {
          let dataFormatada = await this.$formartData.formatar(
            dataVencimento,
            1
          )
          this.datasVencimento.push({
            data: dataFormatada,
            valor: this.contrato.entrada,
          })
          dataVencimento = await this.$formartData.somarDias(
            dataVencimento,
            30
          )
        }
        for (let i = 1; i <= this.contrato.parcelas; i++) {
          let dataFormatada = await this.$formartData.formatar(
            dataVencimento,
            1
          )
          this.datasVencimento.push({ data: dataFormatada, valor: 0 })
          dataVencimento = await this.$formartData.somarDias(
            dataVencimento,
            30
          )
        }
      } else {
        let dataFormatada = await this.$formartData.formatar(dataVencimento, 1)
        this.datasVencimento.push({ data: dataFormatada, valor: 0 })
      }
      let cont = 1
      for (let data of this.datasVencimento) {
        if (cont == 1 && hasEntrada) {
          1
        } else {
          if (
            this.contrato.entrada > 0 &&
            this.contrato.id_forma_pagamento_entrada > 0
          ) {
            let valorConta = (
              (this.nota.valor_liquido - this.contrato.entrada) /
              (this.datasVencimento.length - 1)
            ).toFixed(2)

            if (cont == this.datasVencimento.length) {
              valorConta = (valorConta - ((valorConta * (this.datasVencimento.length - 1)) - (this.nota.valor_liquido - this.contrato.entrada))).toFixed(2)
            }
            data.valor = valorConta

          } else {
            let valorConta = (this.nota.valor_liquido / this.datasVencimento.length).toFixed(2)
            if (cont == this.datasVencimento.length) {
              valorConta = (valorConta - ((valorConta * this.datasVencimento.length) - this.nota.valor_liquido)).toFixed(2)
            }
            data.valor = valorConta
          }
        }
        cont++
      }
      this.reRenderComponents += 1
    },
    //SETAR AS PORCENTAGENS DAS TRIBUTAÇÕES QUE O TIPO DE PESSOA RECEBE
    async setPorcentagensServico () {
      let auxSomaValor = 0,
        somaPisCsllCofins = 0
      if (this.empresa.isenta_imposto == 0 && this.cliente.tipo_pessoa == 2) {
        somaPisCsllCofins =
          (this.empresa.valorCofins * this.nota.valor_bruto) / 100 +
          (this.empresa.valorPis * this.nota.valor_bruto) / 100 +
          (this.empresa.valorCsll * this.nota.valor_bruto) / 100
        auxSomaValor = (
          (this.empresa.valorCofins * this.nota.valor_bruto) /
          100
        ).toFixed(2)
        this.nota.valorCofins = somaPisCsllCofins <= 10.0 ? 0.0 : auxSomaValor
        auxSomaValor = (
          (this.empresa.valorPis * this.nota.valor_bruto) /
          100
        ).toFixed(2)
        this.nota.valorPis = somaPisCsllCofins <= 10.0 ? 0.0 : auxSomaValor
        auxSomaValor = (
          (this.empresa.valorInss * this.nota.valor_bruto) /
          100
        ).toFixed(2)
        this.nota.valorInss = auxSomaValor <= 10.0 ? 0.0 : auxSomaValor
        auxSomaValor = (
          (this.empresa.valorIr * this.nota.valor_bruto) /
          100
        ).toFixed(2)
        this.nota.valorIr = auxSomaValor <= 10.0 ? 0.0 : auxSomaValor
        auxSomaValor = (
          (this.empresa.valorCsll * this.nota.valor_bruto) /
          100
        ).toFixed(2)
        this.nota.valorCsll = somaPisCsllCofins <= 10.0 ? 0.0 : auxSomaValor

        this.tributos =
          parseFloat(this.nota.valorInss) +
          parseFloat(this.nota.valorIr) +
          parseFloat(this.nota.valorCsll) +
          parseFloat(this.nota.valorCofins) +
          parseFloat(this.nota.valorPis)

        this.textoPorcentagensServico =
          somaPisCsllCofins <= 10.0
            ? `Para PIS/COFINS/CSLL \nÉ dispensada a retenção de igual ou inferior a R$ 10,00 exceto no DARF eletrônico emitido por meio do SIAFI (Lei nº 10.833/2003, art. 31 §3º); \nPara IR \nLEI Nº 9.430, DE 27 DE DEZEMBRO DE 1996; Dispensa de Retenção de Imposto de Renda; Art. 67. Fica dispensada a retenção de imposto de renda, de valor igual ou inferior a R$ 10,00 (dez reais);`
            : ""
      } else {
        this.nota.valorInss = 0
        this.nota.valorIr = 0
        this.nota.valorCsll = 0
        this.nota.valorCofins = 0
        this.nota.valorPis = 0
        this.textoPorcentagensServico = ""
      }
      this.reRenderComponents += 1
    },
    //SETAR O JSON QUE É ENVIADO PARA A API PARA SER PROCESSADO
    // Formato DPS Nacional (issue gspro12-app#304) — mesma estrutura que
    // notaAutomatica.vue usa pra emissão nova (identificacao/prest/serv/toma/
    // valores). O backend (NotaController.salvarNotaManaus) envia sempre pro
    // mesmo endpoint fiscal-core /api/v1/dps independente de tipo 1 (emissão)
    // ou tipo 2 (reenvio) — só o pós-processamento no banco muda por tipo, o
    // payload DPS em si tem que ser identico. Sem isso, toda a validacao/
    // seguranca que o backend ja tem pro fluxo DPS (serie, IBGE, CST,
    // passphrase do certificado) nao rodava nesse reenvio.
    async setJsonNota () {
      this.jsonNota.id_contrato = this.contrato.id
      this.jsonNota.json = {
        identificacao: {
          nDPS: this.nota.rps_novo,
          serie: (this.empresa && this.empresa.serie_dps) ? `${this.empresa.serie_dps}` : "1",
          tpAmb: 2, // Homologação (mesmo valor fixo de notaAutomatica.vue, por enquanto)
          dCompet: this.nota.data_emissao,
          // passphrase nao vem mais do frontend (issue #462) - o backend injeta
          // a partir de empresas.senha (Encryption), pelo CNPJ do prestador.
        },
        prest: {
          cnpj: await this.$removerMascara.remove(`${this.empresa.cnpj}`),
          ccm: await this.$removerMascara.remove(
            `${this.empresa.inscricao_municipal}`
          ),
          opSimpNac: (function(opt) {
            if (opt == 2) return "2";
            if (opt == 1 || opt == 3) return "3";
            return "1";
          })(this.empresa.optante_simples_nacional),
          regEspTrib: (this.empresa && this.empresa.regime_especial_tributacao != null)
            ? `${this.empresa.regime_especial_tributacao}`
            : "0",
          regApTribSN: (this.empresa && (this.empresa.optante_simples_nacional == 1 || this.empresa.optante_simples_nacional == 3) && this.empresa.regime_apuracao_simples_nacional)
            ? `${this.empresa.regime_apuracao_simples_nacional}`
            : undefined,
        },
        serv: {
          cTribNac: (this.empresa && this.empresa.codigo_tributacao_nacional)
            ? await this.$removerMascara.remove(`${this.empresa.codigo_tributacao_nacional}`)
            : "071301",
          cTribMun: (this.empresa && this.empresa.codigo_tributacao_municipal)
            ? `${this.empresa.codigo_tributacao_municipal}`.trim()
            : null,
          xDescServ: this.nota.obs,
          cNBS: (this.empresa && this.empresa.codigo_nbs)
            ? await this.$removerMascara.remove(`${this.empresa.codigo_nbs}`)
            : "118032100",
        },
        toma: {
          doc: await this.$removerMascara.remove(`${this.cliente.cpf_cnpj}`),
          tipoDoc: `${this.cliente.tipo_pessoa}`,
          xNome: this.cliente.razao_social || this.cliente.nome_fantasia,
          email: this.cliente.email || "financeiro@exemplo.com",
          fone: await this.$removerMascara.remove(`${this.cliente.telefone}`),
          im: await this.$removerMascara.remove(
            `${this.cliente.inscricao_municipal}`
          ),
          end: {
            xLgr: this.enderecoFaturamento.logradouro
              ? this.enderecoFaturamento.logradouro.substring(0, 100)
              : "",
            nro: this.enderecoFaturamento.numero || "S/N",
            xBairro: this.enderecoFaturamento.nomeBairro || "",
            cMun: this.enderecoFaturamento.codigo_municipio || "",
            uf: this.enderecoFaturamento.uf || "",
            cep: await this.$removerMascara.remove(
              `${this.enderecoFaturamento.cep}`
            ),
          },
        },
        valores: {
          vServ: parseFloat(this.nota.valor_bruto),
          aliq: parseFloat(this.parametros.iss),
          issRetido: !!this.nota.iss_retido,
          vPis: 0,
          vCofins: 0,
          vInss: parseFloat(this.nota.valorInss || 0),
          vIr: parseFloat(this.nota.valorIr || 0),
          vCsll:
            parseFloat(this.nota.valorCsll || 0) +
            parseFloat(this.nota.valorPis || 0) +
            parseFloat(this.nota.valorCofins || 0),
          vTotTribFed: (this.parametros && this.parametros.ibpt_federal)
            ? parseFloat(this.parametros.ibpt_federal)
            : 13.45,
          vTotTribEst: (this.parametros && this.parametros.ibpt_estadual)
            ? parseFloat(this.parametros.ibpt_estadual)
            : 0.0,
          vTotTribMun: (this.parametros && this.parametros.ibpt_municipal)
            ? parseFloat(this.parametros.ibpt_municipal)
            : 4.98,
        },
      }

      // Guarda de Descrição dos Serviços (serv.xDescServ / nota.obs)
      const finalObs = this.obterObsFinal()
      if (!finalObs || !String(finalObs).trim()) {
        const motivo = "A Descrição dos Serviços (Observação da NFS-e) é obrigatória e não pode ficar vazia. Preencha o campo de observação antes de emitir a nota."
        this.bloqueioEmissaoMotivo = motivo
        const erroBloqueio = new Error(motivo)
        erroBloqueio.isBloqueioTemplate = true
        throw erroBloqueio
      }
      this.jsonNota.json.serv.xDescServ = finalObs
      if (this.nota && !this.nota.obs) {
        this.nota.obs = finalObs
      }

      // Injeção de Informações Complementares (infoCompl.xInfComp)
      const resInjecao = this.injetarInfoComplJsonNota()
      if (resInjecao === false) {
        const erroBloqueio = new Error(this.bloqueioEmissaoMotivo || "Configuração fiscal incompleta.")
        erroBloqueio.isBloqueioTemplate = true
        throw erroBloqueio
      }
    },


    //FUNÇÕES PARA SALVAR/ALTERAR VALORES
    //VALIDAR OS CAMPOS QUE PRECISAM SER PREENCHIDOS
    async submitForm () {
      this.$validator.validateAll().then(async result => {
        if (result) {
          if (!this.validarParametrosFiscaisEmpresa()) {
            return;
          }
          this.enviarRps()
        } else {
          this.$vs.notify(this.$notify.Empty)
        }
      })
    },
    //RRENVIO DO RPS PARA A API
    async enviarRps () {
      await this.$vs.loading({
        container: "#loadingNota" + this.fatura.id,
        scale: 0.6
      })
      this.blockActions = await !this.blockActions
      try {
        await this.setJsonNota()
        await this.removeValoresTributacao()
        await this.$http.post("redirectSalvarNota", {
          nota: this.nota,
          json: this.jsonNota,
          datas: this.datasVencimento,
          contrato: this.contrato,
          tipo: 2
        })
        await this.$emit("update")
        this.$vs.notify({
          title: "RPS reenviado com sucesso!",
          text: "Consulte o RPS nas opções da nota cadastrada!",
          color: "success"
        })
      } catch (err) {
        if (err && err.isBloqueioTemplate === true) {
          this.$vs.notify({
            title: "Emissão Bloqueada",
            text: this.bloqueioEmissaoMotivo || err.message,
            color: "danger",
            time: 8000
          });
          return;
        }
        await this.tratarErroHttpPadrao(err)
      } finally {
        this.blockActions = !this.blockActions
        this.close()
        await this.$vs.loading.close(
          "#loadingNota" + this.fatura.id + " > .con-vs-loading"
        )
      }
    },
    //DESCONTO DO ISS
    async descontoValor (evento) {
      if (evento == "change") {
        if (this.nota.iss_retido) {
          let descontoValor = parseFloat(
            (this.nota.valor_bruto * this.parametros.iss).toFixed(2)
          )
          this.nota.valor_liquido = parseFloat(
            (this.nota.valor_liquido - descontoValor).toFixed(2)
          )
          this.desconto = descontoValor
        } else {
          this.nota.valor_liquido = this.nota.valor_liquido + this.desconto
        }
        await this.setDatasVencimento()
        await this.montarObs()
        this.reRenderComponents += 1
      }
    },
    async removeValoresTributacao () {
      delete this.nota.valorCofins
      delete this.nota.valorCsll
      delete this.nota.valorInss
      delete this.nota.valorIr
      delete this.nota.valorPis
    },
    async close () {
      this.nota = Object.assign(this.nota, this._beforeEditingCache)
      this.modal = false
    },

    //GET VALORES PARA A MONTAGEM DO JSON E DA NOTA
    async getEnderecoFaturamento () {
      try {
        this.enderecoFaturamento = await this.$http.get(
          "getEnderecoFaturamento/" + this.cliente.id
        )
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      }
    },
    async getCliente () {
      try {
        this.cliente = await this.$http.get(
          "cliente/" + this.contrato.id_cliente
        )
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      }
    },
    async getEmpresa () {
      try {
        this.empresa = await this.$http.get(
          `empresa/` + this.contrato.id_empresa
        )
        const competencia = this.nota && this.nota.data_emissao ? this.nota.data_emissao : null
        await this.carregarTemplatesEmpresa(this.contrato.id_empresa, competencia)
      } catch (err) {
        await this.tratarErroHttpPadrao(err)
      }
    }

  },
  async mounted () {
    await this.openModal()
  },
  components: {
    ...components,
    Tomador,
    Prestador
  }
};
</script>
<style lang="scss">
.scroll-reenviar-rps {
  height: 80vh !important;
}
</style>
